"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureFlagContext = void 0;
exports.default = FeatureFlagProvider;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Sentry = _interopRequireWildcard(require("@sentry/react"));
var _util = require("../../api/util");
var _util2 = require("./util");
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FeatureFlagContext = exports.FeatureFlagContext = /*#__PURE__*/(0, _react.createContext)(null);
function FeatureFlagProvider(_ref) {
  let {
    children,
    endpoint,
    xformFlags = _util2.xformFeatureFlags
  } = _ref;
  const [featureFlags, setFeatureFlags] = (0, _react.useState)({
    ..._constants.FEATURE_FLAGS_DEV
  });
  const [featureFlagsLoaded, setFeatureFlagsLoaded] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    (0, _util.appRequest)({
      url: (0, _util.createPath)(endpoint)
    }).then(response => {
      var _response$data;
      setFeatureFlags({
        ...xformFlags(((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.Flags) || response.data),
        ...featureFlags
      });
    }).catch(() => {
      // eat the error, as we want to proceed even if feature flags dont exist
    }).finally(() => {
      setFeatureFlagsLoaded(true);
    });
  }, []); // eslint-disable-line

  (0, _react.useEffect)(() => {
    if (featureFlagsLoaded) {
      // eslint-disable-next-line no-console
      console.log("Feature Flags = ".concat(JSON.stringify(featureFlags)));

      // add flags as tags to sentry...
      Object.keys(featureFlags).forEach(flagName => Sentry.setTag(flagName, featureFlags[flagName]));
    }
  }, [featureFlagsLoaded]); // eslint-disable-line

  return /*#__PURE__*/_react.default.createElement(FeatureFlagContext.Provider, {
    value: {
      featureFlagsLoaded,
      featureFlags
    }
  }, children);
}
FeatureFlagProvider.propTypes = {
  endpoint: _propTypes.default.string.isRequired,
  children: _propTypes.default.node.isRequired,
  xformFlags: _propTypes.default.func
};